import inBrowser from './inBrowser';
let cachedBaseUrl = '';

function init(server) {
    if (!inBrowser()) {
        // var config = require('../config/convict');
        // var basePath = config.get('baseUriPath');
        cachedBaseUrl = server.info.uri;
    }
}

function get() {
    if (inBrowser()) {
        return window.location.origin;
    }
    return cachedBaseUrl;
}

export default {
    init,
    get,
};
